import React, { useState } from "react";
import styles from "./index.module.css";
import { Grid, Hidden } from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import FacultyProfile from "./FacultyProfile";
import FacultyWorkLoad from "./FacultyWorkLoad";
import ResearchPublication from "./ResearchPublication";
import ConsultancyTestingProjects from "./ConsultancyTestingProjects";
import SponsoredProjects from "./SponsoredProjects";
import AwardsHonors from "./AwardsHonors";
import PatentInnovation from "./PatentInnovation";
import BookPublished from "./BookPublished";
import BookChapter from "./BookChapter";
import Scholarship from "./Scholarship";
import WorkshopAttended from './WorkshopAttended';
import WorkshopOrganized from './WorkshopOrganized';
import ProfessionalBodies from './ProfessionalBodies';
import ResearchProjects from './ResearchProjects';

const Index = () => {
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
            <Route
              exact
              path="/faculty-contribution"
              component={FacultyProfile}
            />
            <Route
              exact
              path="/faculty-contribution/faculty_workload"
              component={FacultyWorkLoad}
            />
            <Route
              exact
              path="/faculty-contribution/research_publication"
              component={ResearchPublication}
            />
            <Route
              exact
              path="/faculty-contribution/consultancy_project"
              component={ConsultancyTestingProjects}
            />
            <Route
              exact
              path="/faculty-contribution/sponsored_project"
              component={SponsoredProjects}
            />
            <Route
              exact
              path="/faculty-contribution/awards_honors"
              component={AwardsHonors}
            />
            <Route
              exact
              path="/faculty-contribution/patent_innovation"
              component={PatentInnovation}
            />
            <Route
              exact
              path="/faculty-contribution/book_published"
              component={BookPublished}
            />
            <Route
              exact
              path="/faculty-contribution/book_chapter"
              component={BookChapter}
            />
             <Route
              exact
              path="/faculty-contribution/scholarship"
              component={Scholarship}
            />
              <Route
              exact
              path="/faculty-contribution/workshop_organized"
              component={WorkshopOrganized}
            />
              <Route
              exact
              path="/faculty-contribution/workshop_attended"
              component={WorkshopAttended}
            />
              <Route
              exact
              path="/faculty-contribution/research_projects"
              component={ResearchProjects}
            />
              <Route
              exact
              path="/faculty-contribution/professional_bodies"
              component={ProfessionalBodies}
            />
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
